import SearchIcon from '@mui/icons-material/Search';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button, ButtonProps } from 'shared/mui/Buttons';

export type FilterButtonProps = ButtonProps;

export const FilterIdButton: React.FC<FilterButtonProps> = ({
  label,
  color = 'secondary',
  ...restProps
}) => {
  const translate = useTypedTranslate();

  return (
    <Button
      color={color}
      label={label || translate('app.buttons.searchById')}
      startIcon={<SearchIcon />}
      {...restProps}
    />
  );
};
